<template>
  <BareFullScreenPopup
    ref="popup"
    :lock-scroll="true"
  >
    <div class="discount-popup">
      <PopupSubtitle class="discount-popup__title">
        Вкажіть бажану ціну полісу для продажу
      </PopupSubtitle>

      <TextInput
        class="discount-popup__input"
        v-model="discountPrice"
        :formatter="formatPrice"
        :unformatted-on-focus="true"
        @blur="onInputBlur"
        @keydown.enter.native="onSetupDiscount"
      />

      <Slider
        class="discount-popup__slider"
        :min="Number(netPrice)"
        :max="Number(totalPrice)"
        :step="0.01"
        :limit-threshold="getPriceThreshold"
        :show-tooltip="true"
        :value-format="formatPrice"
        :ceil-intermediate="true"
        v-model="discountPrice"
      />

      <p class="discount-popup__hint">
        Не менше максимальної знижки та не більше повної ціни полісу.
      </p>

      <div class="discount-popup__actions">
        <BlueOutlineButton
          class="discount-popup__btn discount-popup__btn--secondary"
          @click="onSetupMaxDiscount"
        >
          Максимальна знижка
        </BlueOutlineButton>
        <BlueButton
          class="discount-popup__btn discount-popup__btn--primary"
          @click="onSetupDiscount"
        >
          Продовжити
        </BlueButton>
      </div>

      <BlueOutlineButton
        class="discount-popup__btn discount-popup__btn--cancel"
        @click="close"
      >
        Скасувати
      </BlueOutlineButton>
    </div>
  </BareFullScreenPopup>
</template>

<script>
import { mapGetters } from 'vuex';
import { PercentCalculator } from '@/shared/lib/number';
import { BlueButton, BlueOutlineButton, Slider, TextInput } from '@/shared/ui/form';
import { PopupSubtitle } from '@/shared/ui/full-screen-popup';
import { BareFullScreenPopup } from '@/shared/ui/popup';

const { calculateValue } = PercentCalculator();

export default {
  props: {
    totalPrice: {
      type: [Number, String],
      required: true,
    },
    netPrice: {
      type: [Number, String],
      required: true,
    },
    price: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      discountPrice: Number(this.price) || Number(this.totalPrice),
    };
  },
  components: {
    BareFullScreenPopup, PopupSubtitle, Slider, TextInput, BlueButton, BlueOutlineButton
  },
  computed: {
    ...mapGetters('currentUserModule', ['getDiscountLimitThreshold']),
    getPriceThreshold() {
      const thresholdValue = calculateValue(Number(this.totalPrice) - Number(this.netPrice), this.getDiscountLimitThreshold) || 0;
      const thresholdPrice = Math.trunc((Number(this.netPrice) + thresholdValue) * 100) / 100;

      return Math.max(thresholdPrice, Number(this.netPrice));
    },
  },
  methods: {
    calculateValue,
    formatPrice(v) {
      const num = Number(v);
      if (!Number.isFinite(num)) return '0.00';
      return num.toFixed(2);
    },
    clampPrice(value) {
      let price = Math.round(Number(value) * 100) / 100;
      if (!Number.isFinite(price)) {
        price = Number(this.totalPrice);
      }
      if (price > Number(this.totalPrice)) {
        price = Number(this.totalPrice);
      }
      if (price < Number(this.getPriceThreshold)) {
        price = this.getPriceThreshold;
      }
      return price;
    },
    onInputBlur() {
      this.discountPrice = this.clampPrice(this.discountPrice);
    },
    open() {
      this.discountPrice = this.clampPrice(this.price || this.totalPrice);
      this.$refs.popup.open();
    },
    togglePopup() {
      this.$refs.popup.togglePopup();
    },
    close() {
      this.$refs.popup.close();
    },
    onSetupDiscount() {
      this.discountPrice = this.clampPrice(this.discountPrice);
      this.$emit('changeDiscountPrice', this.discountPrice);
      this.close();
    },
    onSetupMaxDiscount() {
      this.discountPrice = this.getPriceThreshold;
      this.$emit('changeDiscountPrice', this.getPriceThreshold);
      this.close();
    },
  },
};
</script>

<style scoped lang="scss">
.discount-popup {
  margin: 0 16px;

  &__title {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }

  &__hint {
    font-size: 14px;
    font-weight: 400;
    color: #717680;
    text-align: center;
    margin: 0 0 16px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;

    @media (min-width: 768px) {
      flex-direction: row;
    }
  }

  &__btn {
    height: 50px;
    width: 100%;
    font-size: 16px;
    font-weight: 500;

    &--secondary {
    }
  }
}

::v-deep .fullscreen-popup__header {
  display: flex;
  align-items: center;
}

::v-deep .fullscreen-popup__title {
  width: 100%;
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  margin-right: 0;

  @media (min-width: 768px) {
    margin-right: -24px;
  }
}

::v-deep .fullscreen-popup__content-wrapper {
  max-width: 500px;
  width: 90%;
}

::v-deep .fullscreen-popup__header .popup-close-button {
  top: 0;
  right: 0;

  @media (min-width: 768px) {
    right: -10px;
  }
}
</style>
